import React from 'react';
import { HStack, VStack, Text, Icon } from '@chakra-ui/react';

interface InfoItemProps {
    icon: any;
    label: string;
    value?: string;
    children?: React.ReactNode;
    stacked?: boolean;
}

export const InfoItem: React.FC<InfoItemProps> = ({ icon, label, value, children, stacked = false }) => {
    if (stacked) {
        return (
            <HStack gap={3} align="start">
                <Icon as={icon} boxSize={5} color="yellow.600" flexShrink={0} />
                <VStack align="start" flex={1} gap={1}>
                    <Text fontWeight="medium" color="black" fontSize="md">
                        {label}:
                    </Text>
                    {children ||
                        (value && (
                            <Text color="black" fontSize="md">
                                {value}
                            </Text>
                        ))}
                </VStack>
            </HStack>
        );
    }

    return (
        <HStack gap={3} align="center">
            <Icon as={icon} boxSize={5} color="yellow.600" flexShrink={0} />
            <HStack justify="space-between" flex={1} align="center">
                <Text fontWeight="medium" color="black" fontSize="md">
                    {label}:
                </Text>
                {children ||
                    (value && (
                        <Text color="black" fontSize="md" textAlign="right">
                            {value}
                        </Text>
                    ))}
            </HStack>
        </HStack>
    );
};
